import { render, staticRenderFns } from "./RatesReservations.vue?vue&type=template&id=2e862e96&scoped=true&"
import script from "./RatesReservations.vue?vue&type=script&lang=js&"
export * from "./RatesReservations.vue?vue&type=script&lang=js&"
import style0 from "./RatesReservations.vue?vue&type=style&index=0&id=2e862e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e862e96",
  null
  
)

export default component.exports